import React from "react";
import { Line } from "@ant-design/charts";

const LABEL_MAP: Record<string, string> = {
  "5g-modal-open": "Modal Açılma",
  "5g-compatibility-check": "Uyumluluk Sorgusu",
  "5g-product-click": "Ürün Tıklama",
};

interface FiveGTrendLineProps {
  data: Array<{ date: string; eventType: string; count: string }>;
}

export const FiveGTrendLine: React.FC<FiveGTrendLineProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <span style={{ color: "#8c8c8c" }}>Bu filtrelere ait veri bulunamadı.</span>
    );
  }

  const chartData = data.map((r) => ({
    date: r.date,
    eventType: LABEL_MAP[r.eventType] || r.eventType,
    count: parseInt(r.count, 10),
  }));

  const config = {
    data: chartData,
    xField: "date",
    yField: "count",
    colorField: "eventType",
    color: ["#459cd3", "#FFC900", "#448ab7"],
    point: {
      shapeField: "square",
      sizeField: 4,
    },
    interaction: {
      tooltip: {
        marker: false,
      },
    },
    style: {
      lineWidth: 2,
    },
  };

  return <Line {...config} />;
};
